import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import LangSelect from '@/components/LangSelect';
import Search from '@/components/HeaderSearch';
import currentCall from "./currentCall";
// import OnlineRate from './onlineRate'
import Push from 'push.js';
import 'viewerjs/dist/viewer.css'; // 加载预览图控件
import api from '@/api/navbar';
import * as _ from 'lodash';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    LangSelect: LangSelect,
    Search: Search,
    // OnlineRate,
    currentCall: currentCall
  },
  data: function data() {
    return {
      showButton: true,
      show: false,
      dialogVisible: false,
      optionsViewer: {
        zIndex: 99999
      },
      second: [require('@/icons/img/360_1.png'), require('@/icons/img/360_2.png'), require('@/icons/img/360_3.png')],
      // 360通知提示
      qq: [require('@/icons/img/qq_1.png'), require('@/icons/img/qq_2.png'), require('@/icons/img/qq_3.png')],
      gridData: [],
      time: null,
      driverNoRegCount: 0,
      orderCount: 0,
      rentCount: 0,
      rollingList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'name'])), mapState({
    searchType: function searchType(state) {
      return state.onlineRate.searchType;
    }
  })),
  watch: {
    searchType: function searchType(val) {
      // this.initData()
    }
  },
  created: function created() {
    this.justf();
  },
  mounted: function mounted() {
    this.initData();
    // 开启计时器
    if (this.$can('SHOWMENU', 'monitoring.map')) {
      var _this = this;
      if (!this.time) {
        this.initData();
        this.initOrder();
        this.initRent();
        this.time = setInterval(function () {
          _this.initData();
          _this.initOrder();
          _this.initRent();
        }, 30000);
      }
      this.$EventBus.$on('operation', function (msg) {
        _this.initData();
        _this.initOrder();
        _this.initRent();
      });
    }
    if (this.$can('SHOWMENU', 'drivermgr.account') && !this.$can('SHOWMENU', 'monitoring.map')) {
      this.initOrder(true);
      this.initRent();
    }
  },
  destroyed: function destroyed() {
    // 销毁计时器
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initData: function initData() {
      var _this2 = this;
      if (!this.$can('SHOWMENU', 'monitoring.map')) {
        return;
      }
      var params = {
        groupType: this.searchType
      };
      api.getVehicleOnlineCount(params).then(function (res) {
        var data = res.data,
          status = res.status;
        if (status === '0') {
          _this2.setOnlineRate(data);
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    initOrder: function initOrder(drivermgr) {
      var _this3 = this;
      api.getOrderCount().then(function (res) {
        var data = res.data,
          status = res.status;
        if (status === '0') {
          _this3.driverNoRegCount = data.driverNoRegCount;
          if (!drivermgr) {
            _this3.orderCount = data.orderCount;
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    initRent: function initRent() {
      var _this4 = this;
      api.getRentCount().then(function (res) {
        var data = res.data,
          status = res.status;
        if (status === '0') {
          _this4.rentCount = data;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    /**
     * 跳转页面
     * @param type
     */
    toRouter: function toRouter(type) {
      console.log('type===>>', type);
      var routerName = '/driver-manage/driver-approval';
      if (type === '订单通知') {
        routerName = '/monitorDispatch/PlaceOrder';
      } else if (type === '招租审核') {
        routerName = '/monitorDispatch/information-delivery';
      }
      this.$router.push({
        path: routerName,
        query: {
          name: 'AUDIT'
        }
      });
    },
    handleClose: function handleClose(done) {
      done();
    },
    // 判断提示是否开启
    justf: function justf() {
      var _this5 = this;
      navigator.permissions.query({
        name: 'notifications',
        userVisibleOnly: false,
        sysex: false,
        deviceId: null
      }).then(function (res) {
        _this5.showButton = res.state !== 'granted' && 'https:' == location.protocol;
      });
    },
    openNotice: function openNotice() {
      var _this6 = this;
      Push.Permission.request(function () {
        console.error('同意：');
        _this6.show = false;
        _this6.showButton = false;
        _this6.$message({
          type: 'success',
          message: '开启订单通知成功'
        });
      }, function () {
        _this6.showButton = true;
        if (_this6.show) {
          _this6.dialogVisible = true;
        } else {
          _this6.$message({
            type: 'error',
            message: '开启订单通知失败，请重新开启'
          });
        }
        _this6.show = true;
      }); // 请求通知权限
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    setOnlineRate: function setOnlineRate(value) {
      if (value !== undefined && Array.isArray(value)) {
        value.forEach(function (item, index) {
          item.id = index + '';
          if (item.onlineCount && item.totalLocationCount) {
            var onlineRate = item.onlineCount / item.totalLocationCount;
            item.onlineRate = Math.floor(onlineRate * 100);
          } else {
            item.onlineRate = 0;
          }
          if (item.totalRecordCount && item.totalLocationCount) {
            var accessRate = item.totalLocationCount / item.totalRecordCount;
            item.accessRate = Math.floor(accessRate * 100);
          } else {
            item.accessRate = 0;
          }
        });
        this.rollingList = _.orderBy(value, ['onlineRate'], ['desc']);
      }
    },
    /**
     * 处理在线率色彩
     * @param value 在线率
     * @returns {string} 返回色彩
     */
    onlineRate: function onlineRate(value) {
      if (value >= 60 && value <= 80) {
        return '#E88E3F';
      } else if (value >= 80) {
        return '#59AA8B';
      } else {
        return '#D65849';
      }
    },
    /**
     *
     */
    toRourter: function toRourter() {
      this.$router.push({
        path: '/vehicle-monitor/realTimeInformation',
        query: {
          tab: 'onlineRate'
        }
      });
    }
  }
};